export const config = {
  apiKey: "AIzaSyDwvy86E39KSPesJQKFGfhqNnQ6PhqnqS8",
  authDomain: "fsll-5718b.firebaseapp.com",
  databaseURL: "https://fsll-5718b.firebaseio.com",
  projectId: "fsll-5718b",
  storageBucket: "fsll-5718b.appspot.com",
  messagingSenderId: "358008884470",
};
